var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 31,
    viewBox: "0 0 78 31",
    fill: "none",
    "aria-labelledby": titleId,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alex-logo-title"
  }, "ALEX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alex-logo-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 30.5V27.6C13.1 29.4 10.5 30.5 7.6 30.5C4.1 30.5 0 28.1 0 23.2C0 18 4.1 16 7.6 16C10.6 16 13.1 17 14.6 18.7V15.9C14.6 13.7 12.7 12.2 9.8 12.2C7.5 12.2 5.3 13.1 3.4 14.8L1.1 10.7C3.8 8.3 7.3 7.2 10.7 7.2C15.8 7.2 20.4 9.2 20.4 15.6V30.4H14.6V30.5ZM14.6 23.2C14.1 21.9 11.9 19.9 9.9 19.9C7.6 19.9 5.6 21.1 5.6 23.2C5.6 25.3 7.6 26.5 9.9 26.5C11.8 26.5 14.1 24.7 14.6 23.2Z",
    fill: "#0981B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 30.5V0H27.5V30.5H21.7Z",
    fill: "#0981B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 18.9C28.8 12.5 33.6 7.3 40.2 7.3C46.8 7.3 51.3 12.2 51.3 19.4V20.8H34.9C35.3 23.5 37.5 25.7 41.3 25.7C43.2 25.7 45.7 24.9 47.1 23.6L49.7 27.4C47.5 29.4 44 30.5 40.6 30.5C33.9 30.5 28.8 25.9 28.8 18.9ZM40.2 12.1C36.6 12.1 35 14.6 34.8 16.8H45.7C45.5 14.7 44.1 12.1 40.2 12.1Z",
    fill: "#0981B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6 12.1C74.3 12.1 73.2 11 73.2 9.7C73.2 8.4 74.3 7.3 75.6 7.3C76.9 7.3 78 8.3 78 9.7C78 11 76.9 12.1 75.6 12.1ZM75.6 7.7C74.5 7.7 73.6 8.6 73.6 9.7C73.6 10.8 74.5 11.7 75.6 11.7C76.7 11.7 77.6 10.8 77.6 9.7C77.6 8.6 76.7 7.7 75.6 7.7ZM76.3 11.1L75.6 10H75.1V11.1H74.7V8.3H75.8C76.3 8.3 76.7 8.6 76.7 9.1C76.7 9.7 76.2 9.9 76 9.9L76.7 11H76.3V11.1ZM75.8 8.7H75.1V9.7H75.8C76 9.7 76.3 9.5 76.3 9.2C76.3 8.9 76 8.7 75.8 8.7Z",
    fill: "#0981B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 18.8L71.9 30.5H65.1L60.3 23.2L55.5 30.5H48.7L56.5 18.8L48.7 7.3H55.5L60.3 14.4L65.1 7.3H71.9L64.1 18.8Z",
    fill: "#0981B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexLogo);
export default __webpack_public_path__ + "static/media/alex-logo.c4f8118086f07dfe8cf4b4b08d8d5923.svg";
export { ForwardRef as ReactComponent };